import type { QuillToolbarConfig } from 'src/@vymo/ui/molecules/richTextEditor/types';
import type { NotesState } from './types';

export const NOTES_API = {
  CREATE: '/v1/notes/create',
  GET_ALL: '/v1/notes/getAll',
  USERS: '/v1/notes/users',
};

export const DEFAULT_NOTE_FETCH_LIMIT = 10;
export const NOTE_EDITOR_MAX_LENGTH = 500;
export const NOTE_MENTION_TRIGGER = '@';
export const PRIVATE_NOTE_DESCRIPTION = 'Send messages just visible to you';
export const USER_OPTION_COLOR = '#1D7AFC';

export const NOTE_EDITOR_TOOLBAR_CONFIG: QuillToolbarConfig = [
  [
    'bold',
    'italic',
    'underline',
    'strike',
    { list: 'ordered' },
    { list: 'bullet' },
  ],
];

export const NOTES_INITIAL_STATE: NotesState = {
  notes: [],
  threadNotes: {},
  users: [],
  loading: false,
  loadingMore: false,
  threadLoading: {},
  error: '',
  loadMoreError: '',
  threadError: {},
  isParentEditorActive: true,
};
